import api from "../../../services/api";

export default {
    namespaced: true,
    state: {
        trialCourseHistoryList: [],
        studentCourseSummaryList: [],
        studentCountBySchoolList: [],
        learningHistoryReportByCourse: [],
        learningHistoryReportByLecture: [],
        studentInfoReportList: [],
    },
    mutations: {
        SET_TRIAL_COURSE_HISTORY_LIST(state, data) {
            state.trialCourseHistoryList = data.data;
        },
        SET_STUDENT_COURSE_SUMMARY_LIST(state, data) {
            state.studentCourseSummaryList = data.data;
        },
        SET_STUDENT_COUNT_BY_SCHOOL_LIST(state, data) {
            state.studentCountBySchoolList = data.data;
        },
        SET_LEARNING_HISTORY_REPORT_BY_COURSE(state, data) {
            state.learningHistoryReportByCourse = data;
        },
        SET_LEARNING_HISTORY_REPORT_BY_LECTURE(state, data) {
            state.learningHistoryReportByLecture = data;
        },
        SET_STUDENT_INFO_REPORT_LIST(state, data) {
            state.studentInfoReportList = data.data;
        }
    },
    getters: {
        trialCourseHistoryList(state) {
            return state.trialCourseHistoryList;
        },
        studentCourseSummaryList(state) {
            return state.studentCourseSummaryList;
        },
        studentCountBySchoolList(state) {
            return state.studentCountBySchoolList;
        },
        learningHistoryReportByCourse(state) {
            return state.learningHistoryReportByCourse;
        },
        learningHistoryReportByLecture(state) {
            return state.learningHistoryReportByLecture;
        },
        studentInfoReportList(state) {
            return state.studentInfoReportList;
        }
    },
    actions: {
        async fetchTrialCourseHistoryList(context, params) {
            return await api
                .get(`/v1/course-enroll-trial`, { params })
                .then(({ data }) => {
                    context.commit("SET_TRIAL_COURSE_HISTORY_LIST", data);
                })
                .catch((error) => {
                    console.error("fetchTrialCourseHistoryList: ", error);
                    throw error;
                });
        },
        async fetchStudentCourseSummaryList(context, params) {
            return await api
                .get(`/v1/course-enroll-count-by-member`, { params })
                .then(({ data }) => {
                    context.commit("SET_STUDENT_COURSE_SUMMARY_LIST", data);
                })
                .catch((error) => {
                    console.error("fetchStudentCourseSummaryList: ", error);
                    throw error;
                });
        },
        async fetchStudentCountBySchoolList(context, params) {
            return await api
                .get(`/v1/course-enroll-count-by-education`, { params })
                .then(({ data }) => {
                    context.commit("SET_STUDENT_COUNT_BY_SCHOOL_LIST", data);
                })
                .catch((error) => {
                    console.error("fetchStudentCountBySchoolList: ", error);
                    throw error;
                });
        },
        async fetchLearningHistoryReportByCourse(context, params) {
            return await api
                .get(`/v1/analytics/learning-history/by-course`, { params })
                .then(({ data }) => {
                    context.commit("SET_LEARNING_HISTORY_REPORT_BY_COURSE", data);
                })
                .catch((error) => {
                    console.error("fetchLearningHistoryReportByCourse: ", error);
                    throw error;
                });
        },
        async fetchLearningHistoryReportByLecture(context, params) {
            return await api
                .get(`/v1/analytics/learning-history/by-lecture`, { params })
                .then(({ data }) => {
                    context.commit("SET_LEARNING_HISTORY_REPORT_BY_LECTURE", data);
                })
                .catch((error) => {
                    console.error("fetchLearningHistoryReportByLecture: ", error);
                    throw error;
                });
        },
        async fetchStudentInfoReportList(context, params) {
            return await api
                .get(`/v1/companies/${params.comId}/student-report`, { params: params.attributes })
                .then(({ data }) => {
                    context.commit("SET_STUDENT_INFO_REPORT_LIST", data);
                })
                .catch((error) => {
                    console.error("fetchStudentInfoReportList: ", error);
                    throw error;
                });
        }
    }
}